import { Typography } from '@material-ui/core';

import { useFastFromOCCInfoLang } from './useFastFromOCCInfoLang';

import makeClasses from './FastFromOCCInfo.style';

export function FastFromOCCInfo() {
  const lang = useFastFromOCCInfoLang();

  const _classes = makeClasses();

  return (
    <section className={_classes.section}>
      <div className={_classes.alert}>
        <Typography
          dangerouslySetInnerHTML={{ __html: lang.alert.description }}
        />
      </div>
      <div>
        <Typography component='h2' className={_classes.divTitle}>
          {lang.disclaimer.first.title}
        </Typography>
        <Typography
          className={_classes.divParagraph}
          dangerouslySetInnerHTML={{
            __html: lang.disclaimer.first.description,
          }}
        />
      </div>
      <div>
        <Typography component='h2' className={_classes.divTitle}>
          {lang.disclaimer.second.title}
        </Typography>
        <Typography
          className={_classes.divParagraph}
          dangerouslySetInnerHTML={{
            __html: lang.disclaimer.second.description,
          }}
        />
      </div>
    </section>
  );
}
